export default {
  name: {
    id: 'rm_metal_tantalum_name',
    defaultMessage: 'Tantalum',
  },
  smartphoneLabel: {
    id: 'rm_metal_tantalum_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_tantalum_what_it_does',
    defaultMessage:
      "Tantalum is used in phone capacitors, which store and release tiny, precise bursts of energy, keeping your smartphone's power and operation smooth and stable. It’s highly valued because it can hold a lot of energy in a quantity invisible to the human eye.",
  },
  extractionText1: {
    id: 'rm_metal_tantalum_extraction',
    defaultMessage:
      'Tantalum is extracted from coltan, a mineral found in igneous rock that contains both tantalum and niobium locked together. It can also be recovered as a byproduct from tin slag. The raw ore is dissolved in strong acids to break it down, then tantalum is chemically separated from niobium through solvent extraction. The purified tantalum is heated and converted into a fine metallic powder, the form used inside the capacitors found in every smartphone.',
  },
  quickFactText: {
    id: 'rm_metal_tantalum_quick_fact',
    defaultMessage:
      'A tiny amount of tantalum helps power your phone, and has also fueled two decades of violent conflict.',
  },
  envSummaryText: {
    id: 'rm_metal_tantalum_env_summary',
    defaultMessage:
      'Artisanal and small-scale mining accounts for approximately 60% of global tantalum production, with no environmental oversight and no land rehabilitation required. In eastern DRC, coltan (the ore from which tantalum is extracted) mining destroys tropical forests, causes severe soil erosion, contaminates waterways, and generates radioactive waste, largely invisible in the global supply chain.',
  },
  envWaterText: {
    id: 'rm_metal_tantalum_env_water_text',
    defaultMessage:
      'During tantalum production, artisanal coltan operations divert rivers and workers dig open pits with no drainage management. As a result, sediment runoff from collapsed pits enters local waterways, degrading water quality for downstream communities. No formal water management obligations currently exist for artisanal miners.',
  },
  envSoilText: {
    id: 'rm_metal_tantalum_env_soil_text',
    defaultMessage:
      "Approximately 20-25% of the world's tantalum supply comes from artisanal mining operations, which are significant contributors to soil erosion and deforestation. Coltan extraction involves hand-digging open pits without structural support, which frequently collapse, leaving large areas of bare, unstable soil. Without vegetation cover or a rehabilitation requirement, erosion is severe and permanent. Processing waste also contains naturally occurring radioactive materials, adding a contamination risk that persists long after mining ends.",
  },
  envBiodiversityText: {
    id: 'rm_metal_tantalum_env_biodiversity_text',
    defaultMessage:
      "In the DRC and Rwanda, coltan mining takes place in some of the most biodiverse tropical forests on Earth. Clearing vegetation for mining sites destroys habitats with no rehabilitation required. Coltan extraction directly overlaps with the last remaining habitat of Grauer's gorilla, one of the world's most critically endangered great apes, with fewer than 2,600 individuals left.",
  },
  envClimateText: {
    id: 'rm_metal_tantalum_env_climate_text',
    defaultMessage:
      "No specific data documenting the climate impact of tantalum mining has been recorded. Overall, mining and processing metals are responsible for about 10% of the world's energy-related greenhouse gas emissions.",
  },
  humanSummaryText: {
    id: 'rm_metal_tantalum_human_summary',
    defaultMessage:
      'Tantalum is one of four 3TG conflict minerals classified by the EU. Around 60% of global production comes from artisanal and small-scale miners (ASM) in the DRC. Work factors and conditions include child labour, digging by hand, working informally with no safety equipment, legal protection, or health coverage. Money from mining has helped fund armed groups that cause violence and force people to leave their homes. Despite progress in supply chain traceability, conditions on the ground remain largely unchanged.',
  },
  humanDisplacementText: {
    id: 'rm_metal_tantalum_human_displacement_text',
    defaultMessage:
      'Land use conflicts are common in artisanal coltan mining in the DRC. Miners frequently operate without formal land rights, and communities have no legal recourse when mining begins on their land. Forced large-scale displacement caused by armed groups controlling mining areas has been documented across eastern DRC.',
  },
  humanHealthText: {
    id: 'rm_metal_tantalum_human_health_text',
    defaultMessage:
      'Artisanal coltan miners work in hand-dug pits without protective equipment, exposing them to multiple risks. Pit collapses can cause fatal accidents. Miners may also be exposed to radioactive dust from tantalum ore, a health risk in a sector with little monitoring or medical support. In conflict areas, violence by armed groups adds another layer of danger. Occupational illnesses, injuries and forced labour are structural features of the sector, with few accountability mechanisms.',
  },
  humanChildLabourText: {
    id: 'rm_metal_tantalum_human_child_labour_text',
    defaultMessage:
      'While child labour in artisanal tantalum mining is less documented than in artisanal cobalt mining, it is not absent. Children have been documented working at coltan extraction sites in eastern DRC and Rwanda, often performing dangerous manual labour in remote areas with limited state oversight.',
  },
  humanGenderText: {
    id: 'rm_metal_tantalum_human_gender_text',
    defaultMessage:
      'Women in artisanal mining communities of eastern DRC face specific vulnerabilities in the context of armed conflict and absent governance. Gender-based violence has been documented in mining areas controlled by armed groups, where no rule of law applies and no protection mechanism exists.',
  },
  humanLegalText: {
    id: 'rm_metal_tantalum_human_legal_text',
    defaultMessage:
      'Around 60% of global tantalum production comes from artisanal and small-scale mining, often with limited contracts, safety standards and legal protection. Around 120 armed groups operate in eastern DRC, and some finance their activities through coltan mining and trade. EU Regulation 2017/821 requires due diligence from certain importers of 3TG, meaning tin, tantalum, tungsten and gold, but research suggests its impact at mine level remains limited.',
  },
  geoSummaryText: {
    id: 'rm_metal_tantalum_geo_summary',
    defaultMessage:
      'Tantalum faces a double concentration challenge: at the mining stage, the DRC alone accounts for about 45% of global supply; at the refining stage, China processes more than half of the world’s output. This means both the raw material and its processing are heavily concentrated in politically sensitive regions. Tantalum is one of the 3TG conflict minerals covered by EU Regulation 2017/821, which establishes due-diligence requirements for supply chains from conflict-affected and high-risk areas.',
  },
  geoDugText: {
    id: 'rm_metal_tantalum_geo_dug_text',
    defaultMessage:
      "Mining is highly concentrated: the DRC alone accounts for about 45% of global production, with Nigeria, Rwanda and Brazil together supplying a further ~43%. This geographic concentration creates significant supply chain vulnerability. Despite being the world's leading producing region, the DRC, Nigeria and Rwanda have no published official reserve data, creating additional long-term uncertainty.",
  },
  geoProcessedText: {
    id: 'rm_metal_tantalum_geo_processed_text',
    defaultMessage:
      'China imports the majority of tantalum concentrates worldwide and hosts more than half of the world’s officially recognised tantalum smelters. It then re-exports processed tantalum products to the EU and the United States. As a result, the global electronics industry depends on Chinese refining capacity, including for ore mined elsewhere.',
  },
  geoLeverageText: {
    id: 'rm_metal_tantalum_geo_leverage_text',
    defaultMessage:
      "Tantalum's supply chain is structurally fragile, passing through conflict zones, informal mining networks, and processing chokepoints. Several producing countries formalise this friction through trade restrictions: Level 2 (export taxes) in the DRC and Rwanda; Level 1 (non-automatic export licences, requiring government approval per transaction) in Nigeria and China, giving authorities discretionary power to delay or block exports.",
  },
  supplySummaryText: {
    id: 'rm_metal_tantalum_supply_summary',
    defaultMessage:
      'Tantalum demand is accelerating driven by the global expansion of chip manufacturing, data centres, and 5G devices. Yet almost nothing is recycled from old electronics, and opening new mines takes years. The gap between a growing need and a near-static supply is closing faster than the industry can respond.',
  },
  supplyReservesText: {
    id: 'rm_metal_tantalum_supply_reserves_text',
    defaultMessage:
      "Unlike most metals, tantalum has no global reserve figure, the countries that produce ~80% of the world's supply publish no official data. What experts agree on is that identified resources are broadly adequate for projected demand. The uncertainty is not geological: it is about speed of access and investment.",
  },
  supplyDemandText: {
    id: 'rm_metal_tantalum_supply_demand_text',
    defaultMessage:
      'Demand for tantalum in clean-energy technologies is estimated at around 60 tonnes in 2025 and projected to reach about 140 tonnes by 2050, an increase of over 130%. In 2024, U.S. tantalum apparent consumption rose by 75% as electronics and data-centre demand recovered. Every new semiconductor factory built under industrial policy programmes around the world adds to that pressure and there are many in the pipeline.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_tantalum_recycling_summary',
    defaultMessage:
      'Tantalum sits in the tiny capacitors on every circuit board. During conventional recycling, it oxidises and is lost into slag, standard recycling routes simply do not work. Recovering it requires dedicated processes that barely exist at industrial scale. Every refurbished device keeps its tantalum alive. Every scrapped one loses it forever.',
  },
  recyclingInputText: {
    id: 'rm_metal_tantalum_recycling_input_text',
    defaultMessage:
      'Less than 1% of tantalum used globally comes from recycled consumer products. This rate has not meaningfully improved in years.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_tantalum_recycling_outlook_text',
    defaultMessage:
      'Not without fundamental investment in infrastructure that does not yet exist. The technical barriers are real, but the bigger obstacle is economic: with tantalum worth so little per device, no business case currently exists to build the systems needed to recover it at scale.',
  },
  mine0Region: {
    id: 'rm_metal_tantalum_mine0_region',
    defaultMessage: 'Maniema',
  },
  mine1Region: {
    id: 'rm_metal_tantalum_mine1_region',
    defaultMessage: 'North Kivu',
  },
  mine2Region: {
    id: 'rm_metal_tantalum_mine2_region',
    defaultMessage: 'South Kivu',
  },
  mine3Region: {
    id: 'rm_metal_tantalum_mine3_region',
    defaultMessage: 'Ngoma',
  },
  mine4Region: {
    id: 'rm_metal_tantalum_mine4_region',
    defaultMessage: 'Gatumba',
  },
  mine5Region: {
    id: 'rm_metal_tantalum_mine5_region',
    defaultMessage: 'Musha',
  },
  mine6Region: {
    id: 'rm_metal_tantalum_mine6_region',
    defaultMessage: 'Minas Gerais',
  },
  mine7Region: {
    id: 'rm_metal_tantalum_mine7_region',
    defaultMessage: 'Marble Bar',
  },
} as const
